import { passwordStrength } from 'check-password-strength';

function Step({ reached = false, additionalClasses = '' }) {
	return (
		<div
			className={`h-1 flex-1 rounded transition-all duration-200 ease-in-out ${reached ? 'bg-current' : 'bg-gray-200'} ${additionalClasses}`}
		/>
	);
}

function LevelPassword({ password }) {
	const response = passwordStrength(password);

	const score = response.id;

	let colorClass = '';
	switch (score.toString()) {
		case '3':
			colorClass = 'text-green';
			break;
		case '2':
		case '1':
			colorClass = 'text-yellow-500';
			break;
		case '0':
			colorClass = 'text-red';
			break;
		default:
			break;
	}

	return (
		<div
			className={`mt-1 flex justify-between gap-[6px] ${colorClass} w-full`}
		>
			<Step
				additionalClasses="first"
				reached={response.id >= 0 && !!password}
			/>
			<Step additionalClasses="second" reached={response.id >= 1} />
			<Step additionalClasses="third" reached={response.id >= 2} />
			<Step additionalClasses="fourth" reached={response.id >= 3} />
		</div>
	);
}

export default LevelPassword;
